type TypeActionNameWithTo = {
  name: string
  to: string
  icon: string
}

type PortletTitleCrudType = {
  create: TypeActionNameWithTo
  read: TypeActionNameWithTo
  update: TypeActionNameWithTo
  delete: TypeActionNameWithTo
}

const nameEntity = 'FinancialMoviment'
const nameSource = 'financial/financialMoviments'
const namePageTitle = 'Pagamentos'

const nameActionPageMain: TypeActionNameWithTo = {
  name: 'Pagamentos',
  to: '/financial/financialMoviments',
  icon: ''
}

const nameActions: PortletTitleCrudType = {
  create: {
    name: 'Adicionar',
    to: '/financial/financialMoviments/create/',
    icon: 'fa fa-plus'
  },
  read: {
    name: 'Visualizar',
    to: '/financial/financialMoviments/',
    icon: 'fa fa-list'
  },
  update: {
    name: 'Editar',
    to: '/financial/financialMoviments/update/',
    icon: 'fa fa-edit'
  },
  delete: {
    name: 'Remover',
    to: '#!',
    icon: 'fa fa-remove'
  }
}

export {
  nameEntity,
  nameSource,
  namePageTitle,
  nameActionPageMain,
  nameActions
}
